export default "__VITE_ASSET__BADmiomI__"